var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:{'-active': _vm.loading}},[_c('svg',[_c('use',{attrs:{"xlink:href":"#icon-loader-new"}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }